import { FC } from 'react'
import IconWrapper, { IconWrapperProps } from './IconWrapper'
import { ReactComponent as MyRevertIcon } from './img/revert.svg'

type RevertIconProps = IconWrapperProps

export const RevertIcon: FC<RevertIconProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyRevertIcon />
    </IconWrapper>
  )
}
